export default "__VITE_ASSET__7095e769__"